export default "__VITE_ASSET__CcbItTHo__"